<template>
  <revision-history :api-url="apiUrl" show-user-filter>
    <template #header="{ params }">
      <b-form-group
          :label="$t('Date')"
          class="mb-0 mr-sm-2"
          label-for="date"
          label-sr-only
      >
        <b-form-datepicker
            id="date"
            v-model="params.date"
            :locale="$i18n.locale"
            reset-button
        />
      </b-form-group>
    </template>
  </revision-history>
</template>

<script>
import RevisionHistory from "@/components/RevisionHistory";
import ResourceSelect from "@/components/selects/ResourceSelect";

export default {
  name: 'UserLogs',
  components: {RevisionHistory},
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      user: null
    }
  },
  computed: {
    apiUrl() {
      return `/api/users/${this.id}/logs`
    },
  },
};
</script>
